import { ApolloClient, from, InMemoryCache } from '@apollo/client'

import { dateInitLink } from './clientLinks/dateInitLink'
import { createNetworkLink, TNetworkLinkOptions } from './clientLinks/networkLink/networkLink'
import { getBaseHttpHeaders } from './httpHeaders'

type TOptions = TNetworkLinkOptions

// TODO add retry link, log link (Sentry), ...

/**
 * creates & returns Apollo GQL client connected to the BE server
 * and sets agreed headers to unsure correct translations & access
 * can be potentially used even outside the GqlProvider bellow
 */
export const createGqlClient = (options: TOptions) => {
  const networkLink = createNetworkLink(options)

  // Initialize Apollo Client
  const gqlClient = new ApolloClient({
    cache: new InMemoryCache({
      // https://www.apollographql.com/docs/react/data/fragments/#defining-possibletypes-manually
      possibleTypes: {
        // to make the FPaymentGateway fragment work
        OnlinePaymentGatesInterface: ['OrderOnlinePaymentStatus', 'FinishedOrder'],
      },
      typePolicies: {
        Order: {
          fields: {
            // use cached results for orders in customer’s profile (history)
            totalSum: {
              merge: true,
            },
            // taken from the Driver app
            items: {
              merge: (prev, updated) => {
                return updated
              },
            },
            // to used cached order address on the form screen
            address: {
              merge: true,
            },
          },
        },
        // to use cached results for fast promo on the form screen
        Recipe: {
          fields: {
            price: {
              merge: true,
            },
          },
        },
      },
    }),
    link: from([dateInitLink, networkLink]),
    headers: getBaseHttpHeaders({ authToken: options.authToken, locale: options.locale }),
  })

  return gqlClient
}
